// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.parentTeamsPage .pcal-kids{margin-top:20px}`, "",{"version":3,"sources":["webpack://./src/views/GenericView/ParentView/Teams/ChildrenTeams.scss"],"names":[],"mappings":"AAAA,4BAAA,eAAA","sourcesContent":[".parentTeamsPage .pcal-kids { margin-top:20px; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
